module.exports = __webpack_public_path__ + "static/coming-soon.4497a798.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coming-soon.jpg
// module id = 544
// module chunks = 184314132425989